import React from "react";
import { useStore } from "../../../hooks/useStore";
import { useTranslation } from "../../../hooks/useTranslation";
import PendingRequest from "./PendingRequest/PendingRequest";

const PendingRequestDataMobile = () => {
  const { pendingRequestStore } = useStore();
  const { t, BundleKey } = useTranslation();
  return (
    <>
      {pendingRequestStore.listPendingRequest.length === 0 ? (
        <h3>{t(BundleKey.PENDINGREQUEST_NOTFOUND)}</h3>
      ) : (
        pendingRequestStore.listPendingRequestFilter.map(
          (pendingRequest: any, index: any) => (
            <PendingRequest key={index} pendingRequests={pendingRequest} />
          )
        )
      )}
    </>
  );
};

export default PendingRequestDataMobile;
